import React from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogContent, Grid, TextField, Typography } from "@material-ui/core";

function TextFieldDialog(props) {
  const [value, setValue] = React.useState(props.value);
  const [open, setOpen] = React.useState(props.open);

  return (
    <Dialog open={open}>
      <DialogContent>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            props.onSubmit(value);
            setOpen(false);
          }}
        >
          <Typography>{props.title}</Typography>
          <Grid container>
            <Grid container item>
              <Grid item>
                <TextField
                  autoFocus
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value);
                  }}
                />
              </Grid>
            </Grid>
            <Grid container item>
              <Grid item>
                <Button
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button type={"submit"}>Ok</Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
}

TextFieldDialog.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

export default TextFieldDialog;
